import { render, staticRenderFns } from "./inlandsflug-segment-anzeige.vue?vue&type=template&id=5cf266b5&scoped=true"
import script from "./inlandsflug-segment-anzeige.vue?vue&type=script&lang=js"
export * from "./inlandsflug-segment-anzeige.vue?vue&type=script&lang=js"
import style0 from "./inlandsflug-segment-anzeige.vue?vue&type=style&index=0&id=5cf266b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf266b5",
  null
  
)

export default component.exports